import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import PublicSpaceStore from "../../stores/PublicSpaceStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import PublicSpaceCardDetailsView from "../views/PublicSpaceCardDetailsView";
import GoogleAPILibStore from "../../stores/GoogleAPILibStore";
import LoadingView from "../views/LoadingView";

export default class PublicSpaceContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "googleAPILibState": GoogleAPILibStore.getState(),
            "publicSpaceStore": PublicSpaceStore.getState()
        }
    }

    componentDidMount() {
        this.googleAPILibStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.GOOGLE_API_LIB_STORE_UPDATED, this.handleStoreUpdate);
        this.publicSpaceStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PUBLIC_SPACE_STORE_UPDATE, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GOOGLE_API_LIB_REQUIRED, {});
        EventPublisher.publish(UIInteractionEvents.PUBLIC_SPACE_SET_SPACE_ID, {"id" :this.props.match.params.id})
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.publicSpaceStoreSubscriber);
        EventPublisher.unsubscribe(this.googleAPILibStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "googleAPILibState": GoogleAPILibStore.getState(),
            "publicSpaceStore": PublicSpaceStore.getState()
        });
    };

    render() {
        if (this.state.googleAPILibState.loadingState !== LoadingStates.FINISHED_LOADING ||
            this.state.publicSpaceStore.loadingState === LoadingStates.INITIALIZED ||
            this.state.publicSpaceStore.loadingState === LoadingStates.LOADING) {
            return (
                <LoadingView titleText="Loading Space"/>
            );
        }

        if (this.state.publicSpaceStore.loadingState === LoadingStates.FAILED_TO_LOAD) {
            return (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="alert alert-danger" role="alert">
                                    Sorry we were unable to find the space you are looking for. Please try another one.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div>
                                <PublicSpaceCardDetailsView
                                    spaceId={this.state.publicSpaceStore.space.spaceId}
                                    title={this.state.publicSpaceStore.space.title}
                                    description={this.state.publicSpaceStore.space.description}
                                    pricePerDay={this.state.publicSpaceStore.space.pricePerDay}
                                    minimumDays={this.state.publicSpaceStore.space.minimumDays}
                                    distance={this.state.publicSpaceStore.space.distance}
                                    created={this.state.publicSpaceStore.space.created}
                                    latitude={this.state.publicSpaceStore.space.latitude}
                                    longitude={this.state.publicSpaceStore.space.longitude}
                                    imageNames={this.state.publicSpaceStore.space.imageNames}
                                    status={this.state.publicSpaceStore.space.status}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}